import { isUnauthorizedError } from "util/error-tracking";

export const sendCodeFailureMessage = (error: unknown): string =>
    isUnauthorizedError(error)
        ? "Your session has expired. Please sign in again to continue."
        : "Failed to send two-factor code. Refresh and try again. If you continue to have trouble, please contact support.";
